import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Emulator from './pages/Emulator';
import EmulatorDesmond from './pages/EmulatorDesmond';
import EmulatorTest from './pages/EmulatorTest';
import AuthCallback from './pages/AuthCallback';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/emulator-test" element={<EmulatorTest />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/emulator"
              element={
                <ProtectedRoute>
                  <EmulatorDesmond />
                </ProtectedRoute>
              }
            />
            <Route
              path="/emulator-desmond"
              element={
                <ProtectedRoute>
                  <EmulatorDesmond />
                </ProtectedRoute>
              }
            />
            <Route
              path="/emulator-old"
              element={
                <ProtectedRoute>
                  <Emulator />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
